"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaRejectionFromError = mediaRejectionFromError;
const error_codes_1 = require("./error-codes");
function mediaRejectionFromError(error) {
    switch (error.code) {
        case error_codes_1.ERROR_CODES.MEDIA_TOO_LARGE:
            return 'size';
        case error_codes_1.ERROR_CODES.MEDIA_TYPE_NOT_ALLOWED:
            return 'type';
        case error_codes_1.ERROR_CODES.MEDIA_DIMENSIONS_TOO_SMALL:
            return 'dimensions';
        case error_codes_1.ERROR_CODES.VALIDATION_FAILED: {
            const paths = (error.fieldErrors ?? []).map((field) => field.path);
            if (paths.some((path) => path.endsWith('byteSize')))
                return 'size';
            if (paths.some((path) => path.endsWith('mimeType')))
                return 'type';
            return null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=media-rejection.js.map